'use strict';

// Funzione di supporto per capire la lingua corrente basandoci sul nome del file
function getCurrentLang() {
  var currentPage = window.location.pathname.split('/').pop() || 'index.html';
  // Se la pagina contiene "-it", "chisiamo", "contatti", "prodotti" allora è italiano, altrimenti inglese
  if (
    currentPage.indexOf('-it') !== -1 ||
    currentPage === 'chisiamo.html' ||
    currentPage === 'contatti.html' ||
    currentPage === 'prodotti-servizi.html'
  ) {
    return 'it';
  }
  return 'en';
}

// Home page JS
if (document.getElementById('home-news-list')) {
  var currentLang = getCurrentLang();

  // Apre il modale con l'articolo completo
  var openModal = function openModal(id) {
    // Passiamo il parametro ?lang= alla richiesta del singolo articolo
    fetch('/api/news/' + id + '?lang=' + currentLang)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data.success) return;
        var news = data.data;
        document.getElementById('modal-title').textContent = news.title;
        document.getElementById('modal-date').textContent = news.date;
        document.getElementById('modal-content').textContent = news.content;
        var img = document.getElementById('modal-image');
        if (news.preview_image) {
          img.src = '/' + news.preview_image;
          document.getElementById('modal-img').style.display = 'block';
        } else {
          document.getElementById('modal-img').style.display = 'none';
        }
        document.getElementById('news-modal').style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
  }; // Chiude il modale
  var closeModal = function closeModal() {
    document.getElementById('news-modal').style.display = 'none';
    document.body.style.overflow = '';
  };
  document.getElementById('modal-close').addEventListener('click', closeModal);
  document.getElementById('news-modal').addEventListener('click', function (e) {
    if (e.target === this) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Carica le ultime 3 news filtrate per la lingua corrente
  fetch('/api/news?lang=' + currentLang)
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      var list = document.getElementById('home-news-list');
      list.innerHTML = '';
      if (!data.data || data.data.length === 0) {
        return;
      }

      // Prendi solo le prime 3
      var news = data.data.slice(0, 3);
      news.forEach(function (item) {
        var el = document.createElement('div');
        el.className = 'news-compact-item';
        // Manteniamo "Read More" dinamico o statico a seconda della lingua se necessario, per ora lasciamo la struttura
        var btnText = currentLang === 'it' ? 'Leggi di più' : 'Read More';
        el.innerHTML =
          '<a href="" class="card card--news-compact" data-id="' +
          item.id +
          '">' +
          '<div class="card-img">' +
          '<img src="' +
          (item.preview_image
            ? '/' + item.preview_image
            : 'assets/images/news-hero.jpg') +
          '" alt="">' +
          '</div>' +
          '<div class="card-body">' +
          '<h3 class="h4">' +
          item.title +
          '</h3>' +
          '<div class="btns">' +
          '<button class="btn btn-outline-white">' +
          btnText +
          '</button>' +
          '</div>' +
          '</div>' +
          '</a>';
        el.querySelector('.card').addEventListener('click', function (e) {
          e.preventDefault();
          openModal(this.dataset.id);
        });
        list.appendChild(el);
      });
    });
}

('use strict');

document.addEventListener('DOMContentLoaded', function () {
  // language
  var lang = document.querySelector('.lang');
  if (lang) {
    var langCurr = lang.querySelector('.lang-curr');
    langCurr.addEventListener('click', function (e) {
      e.stopPropagation();
      lang.classList.toggle('is-active');
    });
    document.addEventListener('click', function () {
      lang.classList.remove('is-active');
    });

    // Mapping EN ↔ IT
    var langMap = {
      'index.html': 'index-it.html',
      'about.html': 'chisiamo.html',
      'contact.html': 'contatti.html',
      'news.html': 'news-it.html',
      'products-services.html': 'prodotti-servizi.html',
      'GMF.html': 'GMF-it.html',
      'PCB.html': 'PCB-it.html',
      'privacy-policy.html': 'privacy-policy-it.html',
      'index-it.html': 'index.html',
      'chisiamo.html': 'about.html',
      'contatti.html': 'contact.html',
      'news-it.html': 'news.html',
      'prodotti-servizi.html': 'products-services.html',
      'GMF-it.html': 'GMF.html',
      'PCB-it.html': 'PCB.html',
      'privacy-policy-it.html': 'privacy-policy.html',
    };

    var currentPage = window.location.pathname.split('/').pop() || 'index.html';
    var targetPage = langMap[currentPage];
    if (targetPage) {
      var langLink = lang.querySelector('[data-lang-target]');
      if (langLink) langLink.href = targetPage;
    }
  }
  var body = document.body;

  // scroll handler
  function handleScroll() {
    if (window.scrollY > 0) {
      body.classList.add('is-scrolled');
    } else {
      body.classList.remove('is-scrolled');
    }
  }

  // init + listen
  handleScroll();
  window.addEventListener('scroll', handleScroll);

  // menu toggle
  var toggler = document.querySelector('.toggler');
  if (toggler) {
    toggler.addEventListener('click', function () {
      body.classList.toggle('is-menu');
    });
  }

  // accordion
  var DURATION = 500;
  function createAccordion(_ref) {
    var root = _ref.root,
      itemSelector = _ref.itemSelector,
      triggerSelector = _ref.triggerSelector,
      contentSelector = _ref.contentSelector,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple;
    var list = root;
    if (!list) return;
    function lockList() {
      list.style.minHeight = list.offsetHeight + 'px';
    }
    function unlockList() {
      list.style.transition = 'min-height '.concat(DURATION, 'ms ease');
      setTimeout(function () {
        list.style.minHeight = '';
        list.style.transition = '';
      }, DURATION + 60);
    }
    function openItem(item) {
      var c = item.querySelector(contentSelector);
      if (!c) return;
      item.classList.add('is-expanded');
      c.style.height = 'auto';
      var h = c.scrollHeight;
      c.style.height = '0px';
      requestAnimationFrame(function () {
        return requestAnimationFrame(function () {
          c.style.height = h + 'px';
        });
      });
      c.addEventListener('transitionend', function fn() {
        c.style.height = 'auto';
        c.removeEventListener('transitionend', fn);
      });
    }
    function createAccordionCloseItem(item) {
      var c = item.querySelector(contentSelector);
      if (!c) return;
      c.style.height = c.scrollHeight + 'px';
      requestAnimationFrame(function () {
        return requestAnimationFrame(function () {
          c.style.height = '0px';
        });
      });
      item.classList.remove('is-expanded');
    }
    list.querySelectorAll(triggerSelector).forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest(itemSelector);
        var isOpen = item.classList.contains('is-expanded');
        lockList();
        if (!multiple) {
          list
            .querySelectorAll(''.concat(itemSelector, '.is-expanded'))
            .forEach(function (el) {
              var c = el.querySelector(contentSelector);
              c.style.height = c.scrollHeight + 'px';
            });
          list
            .querySelectorAll(''.concat(itemSelector, '.is-expanded'))
            .forEach(function (el) {
              if (el !== item) createAccordionCloseItem(el);
            });
        }
        if (isOpen) createAccordionCloseItem(item);
        else openItem(item);
        unlockList();
      });
    });
  }
  var serviceList = document.querySelector('.service-list');
  if (serviceList) {
    createAccordion({
      root: serviceList,
      itemSelector: '.service-item',
      triggerSelector: '.service-item h3',
      contentSelector: '.service-details',
    });
  }
  document.querySelectorAll('.product-details-list').forEach(function (list) {
    createAccordion({
      root: list,
      itemSelector: '.product-details-item',
      triggerSelector: '.product-details-item h4',
      contentSelector: '.txt',
    });
  });
});

('use strict');

// News page JS
if (document.getElementById('news-list')) {
  var currentLang = getCurrentLang();

  // Carica gli anni disponibili
  var loadYears = function loadYears() {
    fetch('/api/news/years')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var container = document.getElementById('archive-btns');
        container.innerHTML = '';
        if (!data.data || data.data.length === 0) {
          container.style.display = 'none';
          return;
        }
        data.data.forEach(function (year) {
          var btn = document.createElement('a');
          btn.href = '';
          btn.className = 'btn btn-outline-primary';
          btn.textContent = year;
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            currentYear = year;
            loadNews(year);
            container.querySelectorAll('.btn').forEach(function (b) {
              return b.classList.remove('is-active');
            });
            this.classList.add('is-active');
          });
          container.appendChild(btn);
        });
      });
  }; // Carica le news filtrate per lingua
  var loadNews = function loadNews() {
    var year =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var url = year
      ? '/api/news?year='.concat(year, '&lang=').concat(currentLang)
      : '/api/news?lang=' + currentLang;
    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var list = document.getElementById('news-list');
        var empty = document.getElementById('news-empty');
        list.innerHTML = '';
        if (!data.data || data.data.length === 0) {
          empty.style.display = 'block';
          return;
        }
        empty.style.display = 'none';
        data.data.forEach(function (news) {
          var item = document.createElement('div');
          item.className = 'news-item';
          var btnText = currentLang === 'it' ? 'Leggi di più' : 'Read More';
          item.innerHTML =
            '\n            <a href="" class="card card--news" data-id="'
              .concat(
                news.id,
                '">\n              <div class="card-img">\n                <img src="'
              )
              .concat(
                news.preview_image
                  ? '/' + news.preview_image
                  : 'assets/images/news-hero.jpg',
                '" alt="">\n              </div>\n              <div class="card-body">\n                <div class="card-title">'
              )
              .concat(
                news.title,
                '</div>\n                <div class="card-desc">'
              )
              .concat(
                news.short_desc,
                '</div>\n                <div class="card-b">\n                  <div class="card-date">'
              )
              .concat(
                news.date,
                '</div>\n                  <button class="btn btn-outline-white">'
              )
              .concat(
                btnText,
                '</button>\n                </div>\n              </div>\n            </a>\n          '
              );
          item.querySelector('.card').addEventListener('click', function (e) {
            e.preventDefault();
            openModal(this.dataset.id);
          });
          list.appendChild(item);
        });
      });
  }; // Apre il modale con l'articolo completo
  var openModal = function openModal(id) {
    fetch('/api/news/'.concat(id, '?lang=').concat(currentLang))
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data.success) return;
        var news = data.data;
        document.getElementById('modal-title').textContent = news.title;
        document.getElementById('modal-date').textContent = news.date;
        document.getElementById('modal-content').textContent = news.content;
        var img = document.getElementById('modal-image');
        if (news.preview_image) {
          img.src = '/' + news.preview_image;
          document.getElementById('modal-img').style.display = 'block';
        } else {
          document.getElementById('modal-img').style.display = 'none';
        }
        document.getElementById('news-modal').style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
  }; // Chiude il modale
  var closeModal = function closeModal() {
    document.getElementById('news-modal').style.display = 'none';
    document.body.style.overflow = '';
  };
  var currentYear = 0;
  document.getElementById('modal-close').addEventListener('click', closeModal);
  document.getElementById('news-modal').addEventListener('click', function (e) {
    if (e.target === this) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Init
  loadYears();
  loadNews();
}
